import { AlertCircle, ListChecks, Sparkles } from 'lucide-react'
import { cn } from '@quebon/ui/lib/utils'
import type { ReviewNoteSourceMode } from '@/api/lcReviewNote'

const presentation = {
  ALL: { Icon: ListChecks, idle: 'bg-review-note-all-soft text-review-note-all', active: 'bg-review-note-all-active text-review-note-on-active' },
  ESSENTIAL: { Icon: Sparkles, idle: 'bg-review-note-essential-soft text-review-note-essential', active: 'bg-review-note-essential-active text-review-note-on-active' },
  WRONG: { Icon: AlertCircle, idle: 'bg-review-note-wrong-soft text-review-note-wrong', active: 'bg-review-note-wrong-active text-review-note-on-active' },
} as const

interface Props {
  source: ReviewNoteSourceMode
  selected?: boolean
}

export function ReviewNoteSourceIcon({ source, selected = false }: Props) {
  const { Icon, idle, active } = presentation[source]
  return (
    <span aria-hidden="true" className={cn('inline-flex size-8 shrink-0 items-center justify-center rounded-lg transition-colors', selected ? active : idle)}>
      <Icon data-icon="inline-start" />
    </span>
  )
}
